import { FinanceProposalSnapshotView } from './FinanceProposalSnapshotView'
import {
  formatFormFieldValue,
  formatScalarField,
  getDisplayFormEntries,
  getFormFieldLabel,
  isNestedRecord,
  isResponsavelField,
} from './financeRequestFormDisplay'

type Props = {
  formData: Record<string, unknown>
  showHeading?: boolean
}

function NestedResponsavelCard({
  title,
  value,
}: {
  title: string
  value: Record<string, unknown>
}) {
  const nome = formatScalarField(value.nome)
  const email = formatScalarField(value.email)

  return (
    <div className='rounded-xl border border-white/[0.06] bg-white/[0.03] p-3'>
      <p className='mb-2 text-[10px] font-semibold uppercase tracking-wider text-text-muted'>{title}</p>
      <dl className='space-y-2'>
        <div>
          <dt className='text-[10px] uppercase text-text-muted'>Nome</dt>
          <dd className='text-sm font-medium text-text-primary'>{nome}</dd>
        </div>
        <div>
          <dt className='text-[10px] uppercase text-text-muted'>E-mail</dt>
          <dd className='text-sm font-medium text-text-primary break-all'>{email}</dd>
        </div>
      </dl>
    </div>
  )
}

function FieldTile({ label, value }: { label: string; value: string }) {
  return (
    <div className='rounded-xl border border-white/[0.06] bg-white/[0.03] px-3 py-2.5'>
      <dt className='text-[10px] font-semibold uppercase tracking-wider text-text-muted'>{label}</dt>
      <dd className='mt-1 text-sm font-medium text-text-primary break-words'>{value}</dd>
    </div>
  )
}

export function FinanceRequestFormFields({ formData, showHeading = true }: Props) {
  const { entries, propostaSnapshot } = getDisplayFormEntries(formData)
  if (entries.length === 0 && !propostaSnapshot) return null

  const scalarEntries = entries.filter(
    ([key, value]) => !isNestedRecord(value) || !isResponsavelField(key),
  )
  const responsavelEntries = entries.filter(
    ([key, value]) => isNestedRecord(value) && isResponsavelField(key),
  )

  return (
    <section className='min-w-0 space-y-4'>
      {scalarEntries.length > 0 && (
        <div>
          {showHeading && (
            <h3 className='mb-3 text-sm font-semibold text-text-primary'>Dados enviados</h3>
          )}
          <dl className='min-w-0 grid grid-cols-1 gap-3 text-sm sm:grid-cols-2'>
            {scalarEntries.map(([key, value]) => (
              <FieldTile
                key={key}
                label={getFormFieldLabel(key)}
                value={formatFormFieldValue(key, value)}
              />
            ))}
          </dl>
        </div>
      )}

      {responsavelEntries.length > 0 && (
        <div className='grid grid-cols-1 gap-3 sm:grid-cols-2'>
          {responsavelEntries.map(([key, value]) => (
            <NestedResponsavelCard
              key={key}
              title={getFormFieldLabel(key)}
              value={value as unknown as Record<string, unknown>}
            />
          ))}
        </div>
      )}

      {propostaSnapshot && (
        <div className='min-w-0 overflow-hidden'>
          <FinanceProposalSnapshotView snapshot={propostaSnapshot} />
        </div>
      )}
    </section>
  )
}
